// extracted by mini-css-extract-plugin
export default {"beeyLogo":"beeyLogo__cvwuia","subdomain":"subdomain__wUy5HG","subdomainTitle":"subdomainTitle___VttAt","subdomainSubtitle":"subdomainSubtitle__Ky_3ft"};